import { useEffect, useState } from 'react'

import type { AuthSession, UserRole } from './api/types'
import { AppLayout } from './components/AppLayout'
import { isDevMode } from './config/devMode'
import { useMiniAppAuth } from './hooks/useMiniAppAuth'
import { ErrorScreen } from './screens/ErrorScreen'
import { LinkRequiredScreen } from './screens/LinkRequiredScreen'
import { LoadingScreen } from './screens/LoadingScreen'
import { UnsupportedScreen } from './screens/UnsupportedScreen'
import { MaxShell } from './shells/MaxShell'
import { TelegramShell } from './shells/TelegramShell'

const App = () => {
  const state = useMiniAppAuth()
  const [session, setSession] = useState<AuthSession | null>(null)
  const [devRole, setDevRole] = useState<UserRole>('buyer')

  useEffect(() => {
    if (state.status === 'ready' && state.auth.kind === 'linked') {
      setSession(state.auth.session)
    }
  }, [state])

  if (state.status === 'loading') {
    return <LoadingScreen />
  }

  const { bridge, auth } = state
  const theme = bridge.getTheme()

  const handleDevSessionChange = (nextSession: AuthSession, role: UserRole) => {
    setSession(nextSession)
    setDevRole(role)
  }

  const content = (() => {
    switch (auth.kind) {
      case 'linked': {
        const linkedSession = session ?? auth.session
        return (
          <AppLayout
            bridge={bridge}
            session={linkedSession}
            devRole={isDevMode ? devRole : undefined}
            onDevSessionChange={isDevMode ? handleDevSessionChange : undefined}
          />
        )
      }
      case 'not_linked':
        return (
          <LinkRequiredScreen bridge={bridge} message={auth.message} rfqId={auth.rfqId} />
        )
      case 'unsupported':
        return <UnsupportedScreen />
      case 'error':
        return <ErrorScreen message={auth.message} />
      default:
        return <ErrorScreen message="Неизвестная ошибка" />
    }
  })()

  if (bridge.platform === 'max') {
    return <MaxShell>{content}</MaxShell>
  }

  return <TelegramShell theme={theme}>{content}</TelegramShell>
}

export default App
